import React from "react";
import PropTypes from "prop-types";
import { t } from "@lingui/core/macro";
import transparentImage from "../../assets/images/footer-logo-fallback.png";

function LogoImage({ program_logo, name }) {
  return (
    <figure
      className="Footer-logoFigure"
      style={{
        backgroundImage: `url(${program_logo})`,
      }}
    >
      <img alt={t`${name} logo`} src={transparentImage} className="Footer-logoImage" />
    </figure>
  );
}

LogoImage.propTypes = {
  program_logo: PropTypes.string,
  name: PropTypes.string,
};

export default function Logo({ program }) {
  const { program_logo = "", name = "", external_links = {} } = program;

  let clientWebsite = external_links.CLIENT_WEBSITE || "";
  if (!clientWebsite.startsWith("http://") && !clientWebsite.startsWith("https://")) {
    clientWebsite = "http://" + clientWebsite;
  }

  return (
    <div className="Footer-logo">
      {clientWebsite ? (
        <a href={clientWebsite} target="_blank" rel="noopener noreferrer">
          <LogoImage program_logo={program_logo} name={name} />
        </a>
      ) : (
        <LogoImage program_logo={program_logo} name={name} />
      )}
    </div>
  );
}

Logo.propTypes = {
  program: PropTypes.shape({
    program_logo: PropTypes.string,
    name: PropTypes.string,
    external_links: PropTypes.object,
  }).isRequired,
};
